export function getGTMId(label: string) {
	return `gtm-${label}`;
}
